// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-title {
  color: var(--foreground);
}

.modal-body {
  color: var(--foreground);
}

.color-div {
  position: absolute;
  z-index: 2;
}

.model-popup-form .form-group {
  margin-bottom: 1.1rem;
}
.model-popup-form .col-form-label {
  font-weight: 500;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}
.model-popup-form .form-control {
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
}
.model-popup-form .form-control:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--ring);
  outline: none;
}

.visibility-segment-wrap {
  margin-top: 1.25rem;
  width: 100%;
}

.visibility-segment-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: var(--foreground);
}
.visibility-segment-label .visibility-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: var(--radius-full);
  border: 1px solid var(--border);
  background: var(--card);
  color: var(--muted-foreground);
  font-size: 0.65rem;
  cursor: help;
  transition: all 0.2s ease;
}
.visibility-segment-label .visibility-info-btn:hover {
  background: var(--muted);
  color: var(--foreground);
  border-color: var(--border-strong);
}

.visibility-segment-control {
  display: flex;
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  background: var(--card);
}

.visibility-segment-option {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 1rem 1.25rem;
  border: none;
  border-right: 1px solid var(--border);
  background: var(--card);
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  font-family: inherit;
  text-align: center;
  min-height: 72px;
}
.visibility-segment-option:last-child {
  border-right: none;
}
.visibility-segment-option i {
  font-size: 1.1rem;
  color: var(--muted-foreground);
  transition: color 0.2s ease;
}
.visibility-segment-option span {
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--foreground);
  letter-spacing: -0.01em;
}
.visibility-segment-option small {
  font-size: 0.7rem;
  font-weight: 400;
  color: var(--muted-foreground);
  line-height: 1.3;
}
.visibility-segment-option:hover {
  background: var(--card-hover);
}
.visibility-segment-option.visibility-public.is-active {
  background: var(--primary-soft);
  box-shadow: inset 3px 0 0 0 var(--primary);
}
.visibility-segment-option.visibility-public.is-active i {
  color: var(--primary);
}
.visibility-segment-option.visibility-public.is-active span {
  color: var(--accent-foreground);
}
.visibility-segment-option.visibility-public.is-active small {
  color: var(--success);
}
.visibility-segment-option.visibility-private.is-active {
  background: var(--muted);
  box-shadow: inset 3px 0 0 0 var(--secondary-foreground);
}
.visibility-segment-option.visibility-private.is-active i {
  color: var(--secondary-foreground);
}
.visibility-segment-option.visibility-private.is-active span {
  color: var(--secondary-foreground);
}
.visibility-segment-option.visibility-private.is-active small {
  color: var(--muted-foreground);
}

@media (max-width: 575.98px) {
  .visibility-segment-control {
    flex-direction: column;
  }
  .visibility-segment-option {
    min-height: 0;
    padding: 0.7rem 0.85rem;
    align-items: flex-start;
    text-align: left;
    border-right: none;
    border-bottom: 1px solid var(--border);
  }
  .visibility-segment-option:last-child {
    border-bottom: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/management/modelManagement/styles/popup.scss"],"names":[],"mappings":"AAOA;EACE,wBALW;AADb;;AASA;EACE,wBATW;AAGb;;AASA;EACE,kBAAA;EACA,UAAA;AANF;;AAWE;EACE,qBAAA;AARJ;AAWE;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;AATJ;AAYE;EACE,+BAAA;EACA,+BAAA;AAVJ;AAYI;EACE,4BAnCS;EAoCT,iCAAA;EACA,aAAA;AAVN;;AAmBA;EACE,mBAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBA1DW;AA0Cb;AAkBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,+BAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAhBJ;AAkBI;EACE,wBAAA;EACA,wBAAA;EACA,kCAAA;AAhBN;;AAqBA;EACE,aAAA;EACA,WAAA;EACA,+BAAA;EACA,+BAAA;EACA,gBAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,qCAAA;EACA,uBAAA;EACA,eAAA;EACA,wDAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAlBF;AAoBE;EACE,kBAAA;AAlBJ;AAqBE;EACE,iBAAA;EACA,8BAAA;EACA,2BAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,mBAAA;EACA,wBA1HS;EA2HT,uBAAA;AApBJ;AAuBE;EACE,iBAAA;EACA,gBAAA;EACA,8BAhIU;EAiIV,gBAAA;AArBJ;AAwBE;EACE,6BAAA;AAtBJ;AA2BI;EACE,+BAAA;EACA,0CAAA;AAzBN;AA2BM;EACE,qBAtGQ;AA6EhB;AA4BM;EACE,+BAAA;AA1BR;AA6BM;EACE,qBAAA;AA3BR;AAkCI;EACE,wBAAA;EACA,uDAAA;AAhCN;AAkCM;EACE,kCAzHS;AAyFjB;AAmCM;EACE,kCAAA;AAjCR;AAoCM;EACE,8BAAA;AAlCR;;AA4CA;EACE;IACE,sBAAA;EAzCF;EA4CA;IACE,aAAA;IACA,uBAAA;IACA,uBAAA;IACA,gBAAA;IACA,kBAAA;IACA,sCAAA;EA1CF;EA4CE;IACE,mBAAA;EA1CJ;AACF","sourcesContent":["// Add/Edit Model Popup\n// Colors come from the token design system (src/styles/theme.css)\n$popup-accent: var(--primary);\n$popup-text: var(--foreground);\n$popup-muted: var(--muted-foreground);\n$popup-border: var(--border);\n\n.modal-title {\n  color: $popup-text;\n}\n\n.modal-body {\n  color: $popup-text;\n}\n\n.color-div {\n  position: absolute;\n  z-index: 2;\n}\n\n// Form polish\n.model-popup-form {\n  .form-group {\n    margin-bottom: 1.1rem;\n  }\n\n  .col-form-label {\n    font-weight: 500;\n    font-size: 0.9rem;\n    margin-bottom: 0.35rem;\n  }\n\n  .form-control {\n    border-radius: var(--radius-sm);\n    border: 1px solid $popup-border;\n\n    &:focus {\n      border-color: $popup-accent;\n      box-shadow: 0 0 0 3px var(--ring);\n      outline: none;\n    }\n  }\n}\n\n// Visibility – Professional segmented control\n$public-accent: var(--primary);\n$private-accent: var(--secondary-foreground);\n\n.visibility-segment-wrap {\n  margin-top: 1.25rem;\n  width: 100%;\n}\n\n.visibility-segment-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n  color: $popup-text;\n\n  .visibility-info-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    border-radius: var(--radius-full);\n    border: 1px solid var(--border);\n    background: var(--card);\n    color: var(--muted-foreground);\n    font-size: 0.65rem;\n    cursor: help;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: var(--muted);\n      color: var(--foreground);\n      border-color: var(--border-strong);\n    }\n  }\n}\n\n.visibility-segment-control {\n  display: flex;\n  width: 100%;\n  border: 1px solid $popup-border;\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  background: var(--card);\n}\n\n.visibility-segment-option {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  padding: 1rem 1.25rem;\n  border: none;\n  border-right: 1px solid $popup-border;\n  background: var(--card);\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n  font-family: inherit;\n  text-align: center;\n  min-height: 72px;\n\n  &:last-child {\n    border-right: none;\n  }\n\n  i {\n    font-size: 1.1rem;\n    color: var(--muted-foreground);\n    transition: color 0.2s ease;\n  }\n\n  span {\n    font-weight: 600;\n    font-size: 0.875rem;\n    color: $popup-text;\n    letter-spacing: -0.01em;\n  }\n\n  small {\n    font-size: 0.7rem;\n    font-weight: 400;\n    color: $popup-muted;\n    line-height: 1.3;\n  }\n\n  &:hover {\n    background: var(--card-hover);\n  }\n\n  // Public – selected state\n  &.visibility-public {\n    &.is-active {\n      background: var(--primary-soft);\n      box-shadow: inset 3px 0 0 0 $public-accent;\n\n      i {\n        color: $public-accent;\n      }\n\n      span {\n        color: var(--accent-foreground);\n      }\n\n      small {\n        color: var(--success);\n      }\n    }\n  }\n\n  // Private – selected state\n  &.visibility-private {\n    &.is-active {\n      background: var(--muted);\n      box-shadow: inset 3px 0 0 0 $private-accent;\n\n      i {\n        color: $private-accent;\n      }\n\n      span {\n        color: var(--secondary-foreground);\n      }\n\n      small {\n        color: var(--muted-foreground);\n      }\n    }\n  }\n}\n\n// Each option carries an icon, a title and a sentence of detail. Side by side on\n// a phone that is ~140px per option, which wraps \"Free training · Model Hub\"\n// onto four lines and makes the two look like a broken grid. Stack them, and\n// read left-aligned like the rest of the form.\n@media (max-width: 575.98px) {\n  .visibility-segment-control {\n    flex-direction: column;\n  }\n\n  .visibility-segment-option {\n    min-height: 0;\n    padding: 0.7rem 0.85rem;\n    align-items: flex-start;\n    text-align: left;\n    border-right: none;\n    border-bottom: 1px solid $popup-border;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
